import React, { VFC } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2.5),
    },
  },
  label: {
    textAlign: 'center',
    fontWeight: 'bold',
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'inherit',
    },
  },
}));

interface Props {
  children: string;
  href: string;
}

const LargeButton: VFC<Props> = ({ children, href }: Props) => {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      color="primary"
      className={classes.root}
      classes={{ root: classes.root, label: classes.label }}
      fullWidth
      href={href}
    >
      {children}
    </Button>
  );
};

export default LargeButton;
